import React from 'react'

const Manual_asignar_membresia_usuario_clau = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Asignar membresía al usuario en el Dashboard
        </h2>
        <iframe
          src="https://scribehow.com/embed/Asignar_membresia_al_usuario_en_el_dashboard__cv9OhFa4QumX5OlmWoxNXA?as=scrollable"
          className="scribe-iframe-general-87"
          width="100%"
          height="5300"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_asignar_membresia_usuario_clau
